import {createSubmitRequestTypes} from "./helpers";

export const BEGIN_CHECKOUT = "ACCOUNT:BEGIN_CHECKOUT";
export const beginCheckout = (accountId, orderId) => ({ type: BEGIN_CHECKOUT, accountId, orderId });

export const REQUEST_CREATE_CUSTOMER = "ACCOUNT:REQUEST_CREATE_CUSTOMER";
export const CREATE_CUSTOMER = createSubmitRequestTypes("ACCOUNT:CREATE_CUSTOMER");
export const requestCreateCustomer = () => ({ type: REQUEST_CREATE_CUSTOMER });
export const cancelCreateCustomer = () => ({ type: CREATE_CUSTOMER.CANCEL });

export const REQUEST_CHANGE_CONTACT_DETAILS = "ACCOUNT:REQUEST_CHANGE_CONTACT_DETAILS";
export const CHANGE_CONTACT_DETAILS = createSubmitRequestTypes("ACCOUNT:CHANGE_CONTACT_DETAILS");
export const requestChangeContactDetails = (customerId) => ({ type: REQUEST_CHANGE_CONTACT_DETAILS, customerId });
export const cancelChangeContactDetails = () => ({ type: CHANGE_CONTACT_DETAILS.CANCEL });

export const REQUEST_ASSIGN_REFERRAL_CODE = "ACCOUNT:REQUEST_ASSIGN_REFERRAL_CODE";
export const ASSIGN_REFERRAL_CODE = createSubmitRequestTypes("ACCOUNT:ASSIGN_REFERRAL_CODE");
export const requestAssignReferralCode = (customerId) => ({ type: REQUEST_ASSIGN_REFERRAL_CODE, customerId });
export const cancelAssignReferralCode = () => ({ type: ASSIGN_REFERRAL_CODE.CANCEL });

export const REQUEST_TOGGLE_MARKETING_COMMUNICATIONS = "IDENTITY:REQUEST_TOGGLE_MARKETING_COMMUNICATIONS";
export const TOGGLE_MARKETING_COMMUNICATIONS = createSubmitRequestTypes("IDENTITY:TOGGLE_MARKETING_COMMUNICATIONS");
export const requestToggleMarketingCommunications = (customerId) => ({ type: REQUEST_TOGGLE_MARKETING_COMMUNICATIONS, customerId });
export const cancelToggleMarketingCommunications = () => ({ type: TOGGLE_MARKETING_COMMUNICATIONS.CANCEL });

export const REQUEST_ADD_ACCOUNT = "ACCOUNT:REQUEST_ADD_ACCOUNT";
export const ADD_ACCOUNT = createSubmitRequestTypes("ACCOUNT:ADD_ACCOUNT");
export const requestAddAccount = (customerId) => ({ type: REQUEST_ADD_ACCOUNT, customerId });
export const addAccount = (data, formName) => ({ type: ADD_ACCOUNT.SUBMIT, data, formName });
export const cancelAddAccount = () => ({ type: ADD_ACCOUNT.CANCEL });

export const REQUEST_RENAME_ACCOUNT = "ACCOUNT:REQUEST_RENAME_ACCOUNT";
export const RENAME_ACCOUNT = createSubmitRequestTypes("ACCOUNT:RENAME_ACCOUNT");
export const requestRenameAccount = (accountId) => ({ type: REQUEST_RENAME_ACCOUNT, accountId });
export const renameAccount = (data, formName) => ({ type: RENAME_ACCOUNT.SUBMIT, data, formName });
export const cancelRenameAccount = () => ({ type: RENAME_ACCOUNT.CANCEL });

export const REQUEST_ADD_SHIPPING_ADDRESS = "ACCOUNT:REQUEST_ADD_SHIPPING_ADDRESS";
export const ADD_SHIPPING_ADDRESS = createSubmitRequestTypes("ACCOUNT:ADD_SHIPPING_ADDRESS");
export const requestAddShippingAddress = (accountId) => ({ type: REQUEST_ADD_SHIPPING_ADDRESS, accountId });
export const addShippingAddress = (data, formName) => ({ type: ADD_SHIPPING_ADDRESS.SUBMIT, data, formName });
export const cancelAddShippingAddress = () => ({ type: ADD_SHIPPING_ADDRESS.CANCEL });

export const REQUEST_EDIT_SHIPPING_ADDRESS = "ACCOUNT:REQUEST_EDIT_SHIPPING_ADDRESS";
export const UPDATE_SHIPPING_ADDRESS = createSubmitRequestTypes("ACCOUNT:UPDATE_SHIPPING_ADDRESS");
export const requestEditShippingAddress = (address) => ({ type: REQUEST_EDIT_SHIPPING_ADDRESS, address });
export const updateShippingAddress = (data, formName) => ({ type: UPDATE_SHIPPING_ADDRESS.SUBMIT, data, formName });
export const cancelUpdateShippingAddress = () => ({ type: UPDATE_SHIPPING_ADDRESS.CANCEL });

export const REQUEST_REMOVE_SHIPPING_ADDRESS = "ACCOUNT:REQUEST_REMOVE_SHIPPING_ADDRESS";
export const REMOVE_SHIPPING_ADDRESS = createSubmitRequestTypes("ACCOUNT:REMOVE_SHIPPING_ADDRESS");
export const requestRemoveShippingAddress = (accountId, addressId) => ({ type: REQUEST_REMOVE_SHIPPING_ADDRESS, accountId, addressId });
export const removeShippingAddress = (address, formName) => ({ type: REMOVE_SHIPPING_ADDRESS.SUBMIT, address, formName });
export const cancelRemoveShippingAddress = () => ({ type: REMOVE_SHIPPING_ADDRESS.CANCEL });

export const REQUEST_SET_BILLING_ADDRESS = "ACCOUNT:REQUEST_SET_BILLING_ADDRESS";
export const SET_BILLING_ADDRESS = createSubmitRequestTypes("ACCOUNT:SET_BILLING_ADDRESS");
export const requestSetBillingAddress = (accountId, address) => ({ type: REQUEST_SET_BILLING_ADDRESS, accountId, address });
export const cancelSetBillingAddress = () => ({ type: SET_BILLING_ADDRESS.CANCEL });

export const REQUEST_CHANGE_BILLING_ADDRESS = "ACCOUNT:REQUEST_CHANGE_BILLING_ADDRESS";
export const CHANGE_BILLING_ADDRESS = createSubmitRequestTypes("ACCOUNT:CHANGE_BILLING_ADDRESS");
export const requestChangeBillingAddress = (accountId) => ({ type: REQUEST_CHANGE_BILLING_ADDRESS, accountId });
export const cancelChangeBillingAddress = () => ({ type: CHANGE_BILLING_ADDRESS.CANCEL });

export const REQUEST_SET_TAX_INFO = "ACCOUNT:REQUEST_SET_TAX_INFO";
export const SET_TAX_INFO = createSubmitRequestTypes("ACCOUNT:SET_TAX_INFO");
export const requestSetTaxInfo = (accountId) => ({ type: REQUEST_SET_TAX_INFO, accountId });
export const cancelSetTaxInfo = () => ({ type: SET_TAX_INFO.CANCEL });

export const REQUEST_SET_TAX_EXEMPTION = "ACCOUNT:REQUEST_SET_TAX_EXEMPTION";
export const SET_TAX_EXEMPTION = createSubmitRequestTypes("ACCOUNT:SET_TAX_EXEMPTION");
export const requestSetTaxExemption = (accountId) => ({ type: REQUEST_SET_TAX_EXEMPTION, accountId });
export const cancelSetTaxExemption = () => ({ type: SET_TAX_EXEMPTION.CANCEL });

export const REQUEST_ADD_PRODUCT_TO_CART = "ACCOUNT:REQUEST_ADD_PRODUCT_TO_CART";
export const ADD_PRODUCT_TO_CART = createSubmitRequestTypes("ACCOUNT:ADD_PRODUCT_TO_CART");
export const requestAddProductToCart = (accountId) => ({ type: REQUEST_ADD_PRODUCT_TO_CART, accountId });
export const cancelAddProductToCart = () => ({ type: ADD_PRODUCT_TO_CART.CANCEL });

export const REQUEST_ADD_SUBSCRIPTION_TO_CART = "ACCOUNT:REQUEST_ADD_SUBSCRIPTION_TO_CART";
export const ADD_SUBSCRIPTION_TO_CART = createSubmitRequestTypes("ACCOUNT:ADD_SUBSCRIPTION_TO_CART");
export const requestAddSubscriptionToCart = (accountId) => ({ type: REQUEST_ADD_SUBSCRIPTION_TO_CART, accountId });
export const cancelAddSubscriptionToCart = () => ({ type: ADD_SUBSCRIPTION_TO_CART.CANCEL });

export const REQUEST_EDIT_SUBSCRIPTION_IN_CART = "ACCOUNT:REQUEST_EDIT_SUBSCRIPTION_IN_CART";
export const EDIT_SUBSCRIPTION_IN_CART = createSubmitRequestTypes("ACCOUNT:EDIT_SUBSCRIPTION_IN_CART");
export const requestEditSubscriptionInCart = (accountId) => ({ type: REQUEST_EDIT_SUBSCRIPTION_IN_CART, accountId});
export const cancelEditSubscriptionInCart = () => ({ type: EDIT_SUBSCRIPTION_IN_CART.CANCEL });

export const REQUEST_EDIT_PRODUCT_IN_CART = "ACCOUNT:REQUEST_EDIT_PRODUCT_IN_CART";
export const EDIT_PRODUCT_IN_CART = createSubmitRequestTypes("ACCOUNT:EDIT_PRODUCT_IN_CART");
export const requestEditProductInCart = (accountId, productId) => ({ type: REQUEST_EDIT_PRODUCT_IN_CART, accountId, productId });
export const cancelEditProductInCart = () => ({ type: EDIT_PRODUCT_IN_CART.CANCEL });

// export const REQUEST_CHANGE_BILLING_METHOD = "ACCOUNT:REQUEST_CHANGE_BILLING_METHOD";
// export const CHANGE_BILLING_METHOD = createSubmitRequestTypes("ACCOUNT:CHANGE_BILLING_METHOD");
// export const requestChangeBillingMethod = (accountId) => ({ type: REQUEST_CHANGE_BILLING_METHOD, accountId });
// export const cancelChangeBillingMethod = () => ({ type: CHANGE_BILLING_METHOD.CANCEL });

export const REQUEST_SET_PAYMENT_TERMS = "ACCOUNT:REQUEST_SET_PAYMENT_TERMS";
export const SET_PAYMENT_TERMS = createSubmitRequestTypes("ACCOUNT:SET_PAYMENT_TERMS");
export const requestSetPaymentTerms = (accountId) => ({ type: REQUEST_SET_PAYMENT_TERMS, accountId });
export const cancelSetPaymentTerms = () => ({ type: SET_PAYMENT_TERMS.CANCEL });

export const REQUEST_SET_PAYMENT_CREDIT_CARD = "ACCOUNT:REQUEST_SET_PAYMENT_CREDIT_CARD";
export const SET_PAYMENT_CREDIT_CARD = createSubmitRequestTypes("ACCOUNT:SET_PAYMENT_CREDIT_CARD");
export const requestSetPaymentCreditCard = (accountId) => ({ type: REQUEST_SET_PAYMENT_CREDIT_CARD, accountId });
export const cancelSetPaymentCreditCard = () => ({ type: SET_PAYMENT_CREDIT_CARD.CANCEL });

export const REQUEST_CHANGE_BILLING_STATUS = "ACCOUNT:REQUEST_CHANGE_BILLING_STATUS";
export const CHANGE_BILLING_STATUS = createSubmitRequestTypes("ACCOUNT:CHANGE_BILLING_STATUS");
export const requestChangeBillingStatus = (accountId) => ({ type: REQUEST_CHANGE_BILLING_STATUS, accountId });
export const cancelChangeBillingStatus = () => ({ type: CHANGE_BILLING_STATUS.CANCEL });

export const REQUEST_CHANGE_CART_POLICIES = "ACCOUNT:REQUEST_CHANGE_CART_POLICIES";
export const CHANGE_CART_POLICIES = createSubmitRequestTypes("ACCOUNT:CHANGE_CART_POLICIES");
export const requestChangeCartPolicies = (accountId) => ({ type: REQUEST_CHANGE_CART_POLICIES, accountId });
export const cancelChangeCartPolicies = () => ({ type: CHANGE_CART_POLICIES.CANCEL });

export const REQUEST_CHANGE_SUBSCRIPTION_FREQUENCY = "ACCOUNT:REQUEST_CHANGE_SUBSCRIPTION_FREQUENCY";
export const CHANGE_SUBSCRIPTION_FREQUENCY = createSubmitRequestTypes("ACCOUNT:CHANGE_SUBSCRIPTION_FREQUENCY");
export const requestChangeSubscriptionFrequency = (subscriptionId) => ({ type: REQUEST_CHANGE_SUBSCRIPTION_FREQUENCY, subscriptionId });
export const cancelChangeSubscriptionFrequency = () => ({ type: CHANGE_SUBSCRIPTION_FREQUENCY.CANCEL });

export const REQUEST_CHANGE_8_PACK_PREFERENCE = "ACCOUNT:REQUEST_CHANGE_8_PACK_PREFERENCE";
export const CHANGE_8_PACK_PREFERENCE = createSubmitRequestTypes("ACCOUNT:CHANGE_8_PACK_PREFERENCE");
export const requestChange8PackPreference = (subscriptionId) => ({ type: REQUEST_CHANGE_8_PACK_PREFERENCE, subscriptionId });
export const cancelChange8PackPreference = () => ({ type: CHANGE_8_PACK_PREFERENCE.CANCEL });

export const REQUEST_CHANGE_SUBSCRIPTION_QUANTITY = "ACCOUNT:REQUEST_CHANGE_SUBSCRIPTION_QUANTITY";
export const CHANGE_SUBSCRIPTION_QUANTITY = createSubmitRequestTypes("ACCOUNT:CHANGE_SUBSCRIPTION_QUANTITY");
export const requestChangeSubscriptionQuantity = (subscriptionId, productSku) => ({ type: REQUEST_CHANGE_SUBSCRIPTION_QUANTITY, subscriptionId, productSku });
export const cancelChangeSubscriptionQuantity = () => ({ type: CHANGE_SUBSCRIPTION_QUANTITY.CANCEL });

export const REQUEST_CHANGE_SUBSCRIPTION_PRODUCTS = "ACCOUNT:REQUEST_CHANGE_SUBSCRIPTION_PRODUCTS";
export const CHANGE_SUBSCRIPTION_PRODUCTS = createSubmitRequestTypes("ACCOUNT:CHANGE_SUBSCRIPTION_PRODUCTS");
export const requestChangeSubscriptionProducts = (subscriptionId) => ({ type: REQUEST_CHANGE_SUBSCRIPTION_PRODUCTS, subscriptionId });
export const cancelChangeSubscriptionProducts = () => ({ type: CHANGE_SUBSCRIPTION_PRODUCTS.CANCEL });

export const REQUEST_CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS = "ACCOUNT:REQUEST_CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS";
export const CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS = createSubmitRequestTypes("ACCOUNT:CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS");
export const requestChangeSubscriptionShippingAddress = (accountId, subscriptionId) => ({ type: REQUEST_CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS, accountId, subscriptionId });
export const cancelChangeSubscriptionShippingAddress = () => ({ type: CHANGE_SUBSCRIPTION_SHIPPING_ADDRESS.CANCEL });

export const REQUEST_NEW_SUBSCRIPTION_SHIPPING_ADDRESS = "ACCOUNT:REQUEST_NEW_SUBSCRIPTION_SHIPPING_ADDRESS";
export const NEW_SUBSCRIPTION_SHIPPING_ADDRESS = createSubmitRequestTypes("ACCOUNT:NEW_SUBSCRIPTION_SHIPPING_ADDRESS");
export const requestNewSubscriptionShippingAddress = (accountId, subscriptionId) => ({ type: REQUEST_NEW_SUBSCRIPTION_SHIPPING_ADDRESS, accountId, subscriptionId });
export const cancelNewSubscriptionShippingAddress = () => ({ type: NEW_SUBSCRIPTION_SHIPPING_ADDRESS.CANCEL });

export const REQUEST_VIEW_SUBSCRIPTION_LOG = "ACCOUNT:REQUEST_VIEW_SUBSCRIPTION_LOG";
export const VIEW_SUBSCRIPTION_LOG = createSubmitRequestTypes("ACCOUNT:VIEW_SUBSCRIPTION_LOG");
export const requestViewSubscriptionLog = (subscriptionId) => ({ type: REQUEST_VIEW_SUBSCRIPTION_LOG, subscriptionId });
export const cancelViewSubscriptionLog = () => ({ type: VIEW_SUBSCRIPTION_LOG.CANCEL });

export const REQUEST_VIEW_SUBSCRIPTION_DELIVERY = "ACCOUNT:REQUEST_VIEW_SUBSCRIPTION_DELIVERY";
export const VIEW_SUBSCRIPTION_DELIVERY = createSubmitRequestTypes("ACCOUNT:VIEW_SUBSCRIPTION_DELIVERY");
export const requestViewSubscriptionDelivery = (deliveryId) => ({ type: REQUEST_VIEW_SUBSCRIPTION_DELIVERY, deliveryId });
export const cancelViewSubscriptionDelivery = () => ({ type: VIEW_SUBSCRIPTION_DELIVERY.CANCEL });

export const REQUEST_RESCHEDULE_SUBSCRIPTION_DELIVERY = "ACCOUNT:REQUEST_RESCHEDULE_SUBSCRIPTION_DELIVERY";
export const RESCHEDULE_SUBSCRIPTION_DELIVERY = createSubmitRequestTypes("ACCOUNT:RESCHEDULE_SUBSCRIPTION_DELIVERY");
export const requestRescheduleSubscriptionDelivery = (subscriptionId) => ({ type: REQUEST_RESCHEDULE_SUBSCRIPTION_DELIVERY, subscriptionId });
export const cancelRescheduleSubscriptionDelivery = () => ({ type: RESCHEDULE_SUBSCRIPTION_DELIVERY.CANCEL });

export const REQUEST_RESUME_SUBSCRIPTION_SCHEDULING = "ACCOUNT:REQUEST_RESUME_SUBSCRIPTION_SCHEDULING";
export const RESUME_SUBSCRIPTION_SCHEDULING = createSubmitRequestTypes("ACCOUNT:RESUME_SUBSCRIPTION_SCHEDULING");
export const requestResumeSubscriptionScheduling = (subscriptionId) => ({ type: REQUEST_RESUME_SUBSCRIPTION_SCHEDULING, subscriptionId });
export const cancelResumeSubscriptionScheduling = () => ({ type: RESUME_SUBSCRIPTION_SCHEDULING.CANCEL });

export const REQUEST_PAUSE_SUBSCRIPTION = "ACCOUNT:REQUEST_PAUSE_SUBSCRIPTION";
export const PAUSE_SUBSCRIPTION = createSubmitRequestTypes("ACCOUNT:PAUSE_SUBSCRIPTION");
export const requestPauseSubscription = (subscriptionId) => ({ type: REQUEST_PAUSE_SUBSCRIPTION, subscriptionId });
export const cancelPauseSubscription = () => ({ type: PAUSE_SUBSCRIPTION.CANCEL });

export const REQUEST_CANCEL_SUBSCRIPTION = "ACCOUNT:REQUEST_CANCEL_SUBSCRIPTION";
export const CANCEL_SUBSCRIPTION = createSubmitRequestTypes("ACCOUNT:CANCEL_SUBSCRIPTION");
export const requestCancelSubscription = (subscriptionId) => ({ type: REQUEST_CANCEL_SUBSCRIPTION, subscriptionId });
export const cancelCancelSubscription = () => ({ type: CANCEL_SUBSCRIPTION.CANCEL });

export const REQUEST_RESTART_SUBSCRIPTION = "ACCOUNT:REQUEST_RESTART_SUBSCRIPTION";
export const RESTART_SUBSCRIPTION = createSubmitRequestTypes("ACCOUNT:RESTART_SUBSCRIPTION");
export const requestRestartSubscription = (subscriptionId) => ({ type: REQUEST_RESTART_SUBSCRIPTION, subscriptionId });
export const cancelRestartSubscription = () => ({ type: RESTART_SUBSCRIPTION.CANCEL });

export const REQUEST_RENAME_SUBSCRIPTION = "ACCOUNT:REQUEST_RENAME_SUBSCRIPTION";
export const RENAME_SUBSCRIPTION = createSubmitRequestTypes("ACCOUNT:RENAME_SUBSCRIPTION");
export const requestRenameSubscription = (subscriptionId) => ({ type: REQUEST_RENAME_SUBSCRIPTION, subscriptionId });
export const cancelRenameSubscription = () => ({ type: RENAME_SUBSCRIPTION.CANCEL });

export const REQUEST_ADD_CREDIT_CARD = "ACCOUNT:REQUEST_ADD_CREDIT_CARD";
export const ADD_CREDIT_CARD = createSubmitRequestTypes("ACCOUNT:ADD_CREDIT_CARD");
export const requestAddCreditCard = (accountId) => ({ type: REQUEST_ADD_CREDIT_CARD, accountId });
export const cancelAddCreditCard = () => ({ type: ADD_CREDIT_CARD.CANCEL });

export const REQUEST_CHANGE_CREDIT_CARD = "ACCOUNT:REQUEST_CHANGE_CREDIT_CARD";
export const CHANGE_CREDIT_CARD = createSubmitRequestTypes("ACCOUNT:CHANGE_CREDIT_CARD");
export const requestChangeCreditCard = (accountId) => ({ type: REQUEST_CHANGE_CREDIT_CARD, accountId });
export const cancelChangeCreditCard = () => ({ type: CHANGE_CREDIT_CARD.CANCEL });

export const REQUEST_ASSIGN_DEFAULT_CREDIT_CARD = "ACCOUNT:REQUEST_ASSIGN_DEFAULT_CREDIT_CARD";
export const ASSIGN_DEFAULT_CREDIT_CARD = createSubmitRequestTypes("ACCOUNT:ASSIGN_DEFAULT_CREDIT_CARD");
export const requestAssignDefaultCreditCard = (accountId, paymentMethodId) => ({ type: REQUEST_ASSIGN_DEFAULT_CREDIT_CARD, accountId, paymentMethodId });
export const cancelAssignDefaultCreditCard = () => ({ type: ASSIGN_DEFAULT_CREDIT_CARD.CANCEL });

export const REQUEST_REMOVE_CREDIT_CARD = "ACCOUNT:REQUEST_REMOVE_CREDIT_CARD";
export const REMOVE_CREDIT_CARD = createSubmitRequestTypes("ACCOUNT:REMOVE_CREDIT_CARD");
export const requestRemoveCreditCard = (accountId, paymentMethodId) => ({ type: REQUEST_REMOVE_CREDIT_CARD, accountId, paymentMethodId });
export const cancelRemoveCreditCard = () => ({ type: REMOVE_CREDIT_CARD.CANCEL });

export const REQUEST_VIEW_CHARGE_PAYMENTS = "ACCOUNT:REQUEST_VIEW_CHARGE_PAYMENTS";
export const VIEW_CHARGE_PAYMENTS = createSubmitRequestTypes("ACCOUNT:VIEW_CHARGE_PAYMENTS");
export const requestViewChargePayments = (accountId, salesOrderId) => ({ type: REQUEST_VIEW_CHARGE_PAYMENTS, accountId, salesOrderId });
export const cancelViewChargePayments = () => ({ type: VIEW_CHARGE_PAYMENTS.CANCEL });

export const REQUEST_RECORD_PAYMENT = "ACCOUNT:REQUEST_RECORD_PAYMENT";
export const RECORD_PAYMENT = createSubmitRequestTypes("ACCOUNT:RECORD_PAYMENT");
export const requestRecordPayment = (accountId, salesOrderId) => ({ type: REQUEST_RECORD_PAYMENT, accountId, salesOrderId });
export const cancelRecordPayment = () => ({ type: RECORD_PAYMENT.CANCEL });

export const REQUEST_CHECK_PAYMENT_STATUS = "ACCOUNT:REQUEST_CHECK_PAYMENT_STATUS";
export const CHECK_PAYMENT_STATUS = createSubmitRequestTypes("ACCOUNT:CHECK_PAYMENT_STATUS");
export const requestCheckPaymentStatus = (salesOrderId) => ({ type: REQUEST_CHECK_PAYMENT_STATUS, salesOrderId });
export const cancelCheckPaymentStatus = () => ({ type: CHECK_PAYMENT_STATUS.CANCEL });

export const REQUEST_RETRY_PAYMENT = "ACCOUNT:REQUEST_RETRY_PAYMENT";
export const RETRY_PAYMENT = createSubmitRequestTypes("ACCOUNT:RETRY_PAYMENT");
export const requestRetryPayment = (salesOrderId) => ({ type: REQUEST_RETRY_PAYMENT, salesOrderId });
export const cancelRetryPayment = () => ({ type: RETRY_PAYMENT.CANCEL });

export const REQUEST_ASSIGN_ACCOUNT_VIP_STATUS = "ACCOUNT:REQUEST_ASSIGN_ACCOUNT_VIP_STATUS";
export const ASSIGN_ACCOUNT_VIP_STATUS = createSubmitRequestTypes("ACCOUNT:ASSIGN_ACCOUNT_VIP_STATUS");
export const requestAssignAccountVipStatus = (accountId) => ({ type: REQUEST_ASSIGN_ACCOUNT_VIP_STATUS, accountId });
export const cancelAssignAccountVipStatus = () => ({ type: ASSIGN_ACCOUNT_VIP_STATUS.CANCEL });

export const REQUEST_UNASSIGN_ACCOUNT_VIP_STATUS = "ACCOUNT:REQUEST_UNASSIGN_ACCOUNT_VIP_STATUS";
export const UNASSIGN_ACCOUNT_VIP_STATUS = createSubmitRequestTypes("ACCOUNT:UNASSIGN_ACCOUNT_VIP_STATUS");
export const requestUnassignAccountVipStatus = (accountId) => ({ type: REQUEST_UNASSIGN_ACCOUNT_VIP_STATUS, accountId });
export const cancelUnassignAccountVipStatus = () => ({ type: UNASSIGN_ACCOUNT_VIP_STATUS.CANCEL });

export const REQUEST_DELETE_CUSTOMER = "ACCOUNT:REQUEST_DELETE_CUSTOMER";
export const DELETE_CUSTOMER = createSubmitRequestTypes("ACCOUNT:DELETE_CUSTOMER");
export const requestDeleteCustomer = (customerId) => ({ type: REQUEST_DELETE_CUSTOMER, customerId });
export const cancelDeleteCustomer = () => ({ type: DELETE_CUSTOMER.CANCEL });

export const REQUEST_DELETE_ACCOUNT = "ACCOUNT:REQUEST_DELETE_ACCOUNT";
export const DELETE_ACCOUNT = createSubmitRequestTypes("ACCOUNT:DELETE_ACCOUNT");
export const requestDeleteAccount = (accountId, customerId) => ({ type: REQUEST_DELETE_ACCOUNT, accountId, customerId });
export const cancelDeleteAccount = () => ({ type: DELETE_ACCOUNT.CANCEL });
